export var BillOfLadingType;
(function (BillOfLadingType) {
    BillOfLadingType[BillOfLadingType["Pickup"] = 1] = "Pickup";
    BillOfLadingType[BillOfLadingType["DropOff"] = 2] = "DropOff";
})(BillOfLadingType || (BillOfLadingType = {}));
export const BillOfLadingTypeMap = {
    [BillOfLadingType.Pickup]: "Pickup",
    [BillOfLadingType.DropOff]: "Drop Off",
};
export var BillOfLadingStatus;
(function (BillOfLadingStatus) {
    BillOfLadingStatus[BillOfLadingStatus["Draft"] = 1] = "Draft";
    BillOfLadingStatus[BillOfLadingStatus["Failed"] = 2] = "Failed";
    BillOfLadingStatus[BillOfLadingStatus["Complete"] = 3] = "Complete";
})(BillOfLadingStatus || (BillOfLadingStatus = {}));
export const BillOfLadingStatusMap = {
    [BillOfLadingStatus.Draft]: "Draft",
    [BillOfLadingStatus.Failed]: "Failed",
    [BillOfLadingStatus.Complete]: "Complete",
};
export var BillOfLadingMediaPurpose;
(function (BillOfLadingMediaPurpose) {
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["Roof"] = 1] = "Roof";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["DriverSide"] = 2] = "DriverSide";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["PassengerSide"] = 3] = "PassengerSide";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["CornerFrontPassenger"] = 4] = "CornerFrontPassenger";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["CornerFrontDriver"] = 5] = "CornerFrontDriver";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["CornerRearPassenger"] = 6] = "CornerRearPassenger";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["CornerRearDriver"] = 7] = "CornerRearDriver";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["Odometer"] = 8] = "Odometer";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["Signatures"] = 9] = "Signatures";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["Additional"] = 10] = "Additional";
    BillOfLadingMediaPurpose[BillOfLadingMediaPurpose["PowerUnit"] = 11] = "PowerUnit";
})(BillOfLadingMediaPurpose || (BillOfLadingMediaPurpose = {}));
